
export const getProductionQueryInfo = (state, props) => state.production.queryInfo;

export const getProductionSelected = (state, props) => state.production.selected;